import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { ReadyPlanDetailsFragment } from "src/routes/developments/plan-and-options/PlanDetailsPage.generated";
type WelcomeReadyPlanModalProps = { readyPlans: ReadyPlanDetailsFragment[] };
export function WelcomeReadyPlanModal(props: WelcomeReadyPlanModalProps) {
  const { readyPlans } = props;
  const { closeModal } = useModal();
  const readyPlanNames = readyPlans.map((rp) => rp.name).join(", ");
  const development = readyPlans[0].development?.name!;

  return (
    <>
      <ModalHeader>Welcome to the ReadyPlan Workflow!</ModalHeader>
      <ModalBody>
        <div>
          <div css={Css.mb2.$}>
            <h2 css={Css.mdSb.blue700.$}>What is a ReadyPlan?</h2>
            <p css={Css.md.$}>
              ReadyPlans are <span css={Css.mdSb.$}>development-level architectural plan templates </span>
              with options that create a custom look and feel to a home. ReadyPlans can later be configured on projects
              on the Lot Summary sheet, and set the framework to build scope for Development Templates.
            </p>
          </div>

          <div css={Css.mb2.$}>
            <h2 css={Css.mdSb.blue700.$}>Next Steps</h2>
            <p css={Css.md.mb2.$}>
              This ReadyPlan, <span css={Css.mdSb.$}>{readyPlanNames}</span>, will be available for the all lots in
              development <span css={Css.mdSb.$}>{development}</span>.
            </p>
            <p css={Css.md.$}>Follow the steps in the tabs at the bottom of the screen.</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Continue" onClick={closeModal} />
      </ModalFooter>
    </>
  );
}
